import './styles/global.css'
import './lib/router' // Initialize router
import App from './App.svelte'

const app = new App({
	target: document.getElementById('app')!,
})

export default app
